module.exports = __webpack_public_path__ + "img/darkly.040cdb76.png";